import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppContext from "context/Context";

import NavbarTop from "modules/navbar/top/NavbarTop";
import NavbarVertical from "modules/navbar/vertical/NavbarVertical";
import secureLocalStorage from "react-secure-storage";
import ReminderClockOut from "modules/all_authentication_pop_ups/clock_out_reminder/ReminderClockOut";
import YesterdayClockOutWarning from "modules/all_authentication_pop_ups/clock_out_warning/YesterdayClockOutWarning";
import { userCheckedInOut } from "modules/attendence_leave_tracker/api";
import moment from "moment";
import ApprovalPopUpForManager from "modules/all_authentication_pop_ups/approval_reminder_popup_for_managers/ApprovalPopUpForManager";
import LoggedInToday from "modules/all_authentication_pop_ups/logged_in_popup/LoggedInToday";
import { userHouseConfig } from "config";
import ActivityTracker from "modules/all_authentication_pop_ups/ActivityTracker/ActivityTracker";
import { currentUser } from "modules/utilities/utility";
import useLayoutMode from "hooks/useLayoutMode";
import "assets/css/antd-tab-overrides.css";


const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const layoutMode = useLayoutMode();
  const userShift = secureLocalStorage.getItem('shift');
  const isFirstLogin = secureLocalStorage.getItem('is_first_login');
  const isNotClockedOutYesterday = secureLocalStorage.getItem('is_not_clocked_out_yesterday');
  const userHouse = secureLocalStorage.getItem('house');

  const {
    config: { navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleWFHUpdate = (isWFH) => {
    const now = moment();
    const today = moment().format('DD-MM-YYYY');
    const eightAM = moment().startOf('day').add(8, 'hours');
    const sixPM = moment().startOf('day').add(18, 'hours');

    const makeUserClockIn = () => {
      try {
        userCheckedInOut({ isLoginRequest: true, 'source': 'WEB', isWFH });
        secureLocalStorage.setItem('logged_the_user_in', today);
      } catch (error) {
        console.log('error', error);
      }
    };

    if (now.isAfter(eightAM) && now.isBefore(sixPM) && userHouseConfig.includes(userHouse)) {
      if(isFirstLogin || secureLocalStorage.getItem('logged_the_user_in') !== today){
        makeUserClockIn();
      }
    } else if(secureLocalStorage.getItem('logged_the_user_in') && userHouseConfig.includes(userHouse)){
      secureLocalStorage.removeItem('logged_the_user_in');
    }
  };

  return (
    <div className={"container-fluid"}>
      {(navbarPosition === "vertical" || navbarPosition === "combo") && (
        <NavbarVertical />
      )}
      <div className="content">
       <ActivityTracker />
        <NavbarTop />
        {isFirstLogin && userHouseConfig.includes(userHouse) ? <LoggedInToday firstLogin={ true } onWFHUpdate={handleWFHUpdate} /> : <></>}
        <ApprovalPopUpForManager /> 
        <ReminderClockOut shiftTime={userShift} />
        {isNotClockedOutYesterday && isFirstLogin && userHouseConfig.includes(userHouse) ? <YesterdayClockOutWarning didClockOutYesterday={isNotClockedOutYesterday} /> : <></>}
        <Outlet />
      </div>
    </div>
  );
};
export default MainLayout;
